const getSelectionKey = (values = []) =>
  [...new Set(values.map(String))].sort().join('|');

export const findSavedWorkSchedule = ({
  response,
  values,
  previousIds = [],
  schedules = [],
}) => {
  const isEditing = values._draftMode === 'edit';
  const savedId =
    response?.periodId ??
    response?.workSchedulePeriodId ??
    response?.id ??
    (isEditing
      ? values.workSchedulePeriodId ?? values.periodId ?? values.id
      : undefined);

  if (savedId !== undefined && savedId !== null) {
    return schedules.find(
      (schedule) => String(schedule.id) === String(savedId)
    );
  }

  const previousIdSet = new Set(previousIds.map(String));
  const newSchedules = schedules.filter(
    (schedule) => !previousIdSet.has(String(schedule.id))
  );
  if (newSchedules.length === 1) return newSchedules[0];

  const month = values.period?.startMonth || values.startMonth;
  const serviceId =
    values.workScheduleServiceNameId ??
    values.serviceSetIds?.[0] ??
    values.serviceSets?.[0]?.id;
  const allCompanyAddresses =
    values.allCompanyAddresses ?? values.address?.allCompanyAddresses;
  const houseIds = allCompanyAddresses
    ? []
    : values.houseIds || values.address?.houseIds || [];
  const matches = newSchedules.filter(
    (schedule) =>
      (schedule.period?.startMonth || schedule.startMonth) === month &&
      String(
        schedule.workScheduleServiceNameId ?? schedule.serviceSetIds?.[0]
      ) === String(serviceId) &&
      getSelectionKey(schedule.houseIds || schedule.address?.houseIds || []) ===
        getSelectionKey(houseIds) &&
      getSelectionKey(
        (schedule.workers || schedule.performers || []).map(
          (worker) => worker.id
        )
      ) === getSelectionKey(Object.keys(values.workIntervals || {}))
  );

  return matches.length === 1 ? matches[0] : undefined;
};
